import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LWAReasonsGridComponent } from './lwa-reasons-grid/left-without-assistant-reasons-grid.component';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';

const routes: Routes = [
  { path: '', component: LWAReasonsGridComponent, canDeactivate: [UnSavedChangesRouteGuard]  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LWAReasonsRoutingModule { }
